import uuid4 from './uuid4';
import _ from 'underscore';
import contextualize from './contextualize';

function expires(hours) {
  if (!hours) {
    return null;
  }

  var date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  return date.toGMTString();
}

function domain() {
  return window.location.hostname.split('.').slice(-2).join('.');
}

function setCookie(name, value, hours) {
  var pairs = [[name, value]];

  if (hours) {
    pairs.push(['expires', expires(hours)]);
  }

  pairs.push(['domain', domain()]);
  pairs.push(['path', '/']);
  document.cookie = pairs.map(function (pair) {
    return pair.join('=');
  }).join('; ');
}

function getValue(name) {
  var regex = new RegExp(name + "=([^\\s;]*)", 'ig');
  var matched = regex.exec(document.cookie);

  if (matched) {
    return decodeURIComponent(matched[1]);
  }

  return uuid4();
}

function toCutlassFormat(accountId, userId, events) {
  return {
    visit: {
      visitor_id: getValue(this.options.visitorCookie),
      account_id: accountId,
      user_id: userId,
      id: getValue(this.options.visitCookie),
      referrer: document.referrer,
      user_agent: navigator.userAgent,
      domain: document.location.hostname
    },
    events: events
  };
}

function setupCookies() {
  setCookie(this.options.visitCookie, getValue(this.options.visitCookie), this.options.visitTTL);
  setCookie(this.options.visitorCookie, getValue(this.options.visitorCookie), this.options.visitorTTL);
}

function eventProperties(el) {
  var sectionName = el.closest('*[data-section]') && el.closest('*[data-section]').getAttribute('data-section');
  return {
    tag: el.tagName.toLowerCase(),
    id: el.getAttribute('id'),
    "class": el.getAttribute('class'),
    page: window.location.pathname,
    section: sectionName
  };
}

function broadside(action, data) {
  if (data.length === 0) {
    return;
  }

  if (this.cutlassUrl != null) {
    var url = this.cutlassUrl + '/' + action;
    data = JSON.stringify(data);

    if (navigator.sendBeacon(url, data)) {
      this.events = [];
    }
  }
}

function eventNameBase(el) {
  return el.getAttribute('data-cutlass-event') || idEventName(el) || classEventName(el) || tagEventName(el);
}

function idEventName(el) {
  if (el.hasAttribute('id')) {
    return 'id$' + el.getAttribute('id');
  } else {
    return null;
  }
}

function classEventName(el) {
  if (el.hasAttribute('class')) {
    return 'class$' + el.getAttribute('class');
  } else {
    return null;
  }
}

function tagEventName(el) {
  return 'tag$' + el.tagName.toLowerCase();
}

function handleCustomDomEvents(e) {
  switch (e.type) {
    case Events.cutlassEvent:
      this.addEvent(e.detail.name, _.omit(e.detail, 'name'));
      break;
  }
}

function addDocumentListener(event, handler) {
  this._documentListeners.push({
    event: event,
    handler: handler
  });

  document.addEventListener(event, handler);
}

var Events = {
  cutlassEvent: 'cutlass:event'
};

function cutlassEvent(element, name, data) {
  if (data === void 0) {
    data = {};
  }

  var event = new CustomEvent(Events.cutlassEvent, {
    bubbles: true,
    detail: Object.assign({}, {
      name: name
    }, data)
  });
  element.dispatchEvent(event);
}

var Cannon = /*#__PURE__*/function () {
  function Cannon(cutlassUrl, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$visitCookie = _ref.visitCookie,
        visitCookie = _ref$visitCookie === void 0 ? 'cutlass_visit' : _ref$visitCookie,
        _ref$visitorCookie = _ref.visitorCookie,
        visitorCookie = _ref$visitorCookie === void 0 ? 'cutlass_visitor' : _ref$visitorCookie,
        _ref$visitTTL = _ref.visitTTL,
        visitTTL = _ref$visitTTL === void 0 ? 4 : _ref$visitTTL,
        _ref$visitorTTL = _ref.visitorTTL,
        visitorTTL = _ref$visitorTTL === void 0 ? 14 * 24 : _ref$visitorTTL,
        _ref$trackingOnHold = _ref.trackingOnHold,
        trackingOnHold = _ref$trackingOnHold === void 0 ? false : _ref$trackingOnHold;

    this.cutlassUrl = cutlassUrl;
    this.options = {
      visitCookie: visitCookie,
      visitorCookie: visitorCookie,
      visitTTL: visitTTL,
      visitorTTL: visitorTTL
    };
    this.accountId = null;
    this.userId = null;
    this.events = [];
    this.canFire = !trackingOnHold;
    this._documentListeners = []; // Track what we add, so we can remove it

    if (this.canFire) {
      setupCookies.call(this);
    }
  }

  var _proto = Cannon.prototype;

  _proto.addEvents = function addEvents(events) {
    this.events = this.events.concat(events);

    if (this.canFire) {
      broadside.call(this, 'events', toCutlassFormat.call(this, this.accountId, this.userId, this.events));
    }
  };

  _proto.addEvent = function addEvent(event, props) {
    this.addEvents([{
      name: event,
      properties: props,
      url: window.location.href,
      query_string: window.location.search
    }]);
  };

  _proto.trackView = function trackView(props) {
    var properties = {
      url: window.location.href,
      title: document.title,
      page: window.location.pathname
    };

    if (props) {
      for (var name in props) {
        if (Object.prototype.hasOwnProperty.call(props, name)) {
          properties[name] = props[name];
        }
      }
    }

    this.addEvent('$view', properties);
  };

  _proto.trackClicks = function trackClicks() {
    var _this = this;

    addDocumentListener.call(this, 'click', function (e) {
      var target;

      if (e.target.matches('a, button, input[type=submit]')) {
        target = e.target;
      } else {
        target = e.target.closest('a, button, input[type=submit]');
      }

      if (target) {
        var name = eventNameBase(target) + ':click';
        var properties = eventProperties(target);
        properties.href = target.getAttribute('href');

        _this.addEvent(name, properties);
      }
    });
  };

  _proto.trackSubmits = function trackSubmits() {
    var _this2 = this;

    addDocumentListener.call(this, 'submit', function (e) {
      if (e.target.matches('form')) {
        var properties = eventProperties(e.target);
        var name = eventNameBase(e.target) + ':submit';

        _this2.addEvent(name, properties);
      }
    });
  };

  _proto.trackChanges = function trackChanges() {
    var _this3 = this;

    addDocumentListener.call(this, 'change', function (e) {
      if (e.target.matches('input, textarea, select')) {
        var properties = eventProperties(e.target);
        var name = eventNameBase(e.target) + ':change';

        _this3.addEvent(name, properties);
      }
    });
  };

  _proto.trackCustomDomEvents = function trackCustomDomEvents() {
    var _this4 = this;

    Object.values(Events).forEach(function (eventType) {
      addDocumentListener.call(_this4, Events.cutlassEvent, handleCustomDomEvents.bind(_this4));
    });
  };

  _proto.trackAll = function trackAll() {
    this.trackView();
    this.trackClicks();
    this.trackSubmits();
    this.trackChanges();
    this.trackCustomDomEvents();
  };

  _proto.remove = function remove() {
    var _this$_documentListen;

    (_this$_documentListen = this._documentListeners) === null || _this$_documentListen === void 0 ? void 0 : _this$_documentListen.forEach(function (_ref2) {
      var event = _ref2.event,
          handler = _ref2.handler;
      document.removeEventListener(event, handler);
    });
  }
  /**
   * When setup with `trackingOnHold`, this unqueues all the events and allows tracking
   */
  ;

  _proto.allowTracking = function allowTracking() {
    this.canFire = true;
    setupCookies.call(this);
    broadside.call(this, 'events', toCutlassFormat.call(this, this.accountId, this.userId, this.events));
  };

  return Cannon;
}();

export { Cannon, contextualize, Events, cutlassEvent };
window.Cutlass = {
  uuid4: uuid4,
  Cannon: Cannon
};